import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/admin/user/"

function baseApi() {
    function insertUserCotton(data) {
        return Post(baseUrl + "insertUserCotton", data)
    }

    function batchInsertUserCotton(data) {
        return Post(baseUrl + "batchInsertUserCotton", data)
    }

    function deleteUserCotton(data) {
        return Post(baseUrl + "deleteUserCotton", data)
    }

    function updateUserCotton(data) {
        return Post(baseUrl + "updateUserCotton", data)
    }

    function deleteCaptchaSendLimit(data) {
        return Post(baseUrl + 'deleteCaptchaSendLimit', data);
    }

    function queryUserCotton(data) {
        return Post(baseUrl + "queryUserCotton", data)
    }

    return {
        insertUserCotton,
        batchInsertUserCotton,
        updateUserCotton,
        deleteUserCotton,
        deleteCaptchaSendLimit,
        queryUserCotton
    }
}

export const cottonUserApi = baseApi()